import React from 'react';
import UserTaggableInput from 'components/pure/utils/form/user-taggable-input/UserTaggableInput';
import './ScorecardQuestionRow.styl';
import ScorecardQuestionReason from 'components/pure/scorecards/ScorecardQuestionReason';
import CommentIcon from 'components/pure/scorecards/icons/CommentIcon';
import ScorecardAnswerBubbles from 'components/pure/scorecards/ScorecardAnswerBubbles';

export default class ScorecardQuestionRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.onSelectAnswer = this.onSelectAnswer.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  onSelectAnswer(questionId, answer) {
    const {answer: oldAnswer} = this.props;

    if (oldAnswer) {
      this.props.onRemoveAnswer(questionId);
    }

    this.props.onAddAnswer(questionId, answer);
    this.setState({focused: true});
  }

  componentDidMount() {
    document.addEventListener('click', this.onClick);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.onClick);
  }

  onClick(e) {
    if (this.ref && this.ref.contains(e.target)) {
      this.setState({focused: true});
    } else {
      this.setState({focused: false});
    }
  }

  render() {
    const {
      question,
      scoringScheme,
      reasonScheme,
      index,
      answer,
      comment,
      reason,
      onAddComment,
      onReasonChange,
      extraWide,
    } = this.props;

    const {allowComments} = question;

    const shouldShowComment =
      (allowComments && this.state.focused && answer !== undefined) || comment;

    return (
      <div key={question.id} className="question-row-wrapper" ref={r => (this.ref = r)}>
        <div className="row question-row">
          <div className="left question-text">
            {index + 1}. {question.text}
          </div>
          <div className="right">
            <ScorecardAnswerBubbles
              scoringScheme={scoringScheme}
              question={question}
              answer={answer}
              onSelectAnswer={this.onSelectAnswer}
              extraWide={extraWide}
            />
          </div>
        </div>
        <div className="row question-row">
          <div className="second-row-container">
            <ScorecardQuestionReason
              reason={reason}
              reasonScheme={reasonScheme}
              answer={answer}
              onReasonChange={onReasonChange}
              questionId={question.id}
            />
            {shouldShowComment && (
              <div className={'comment-container'}>
                <CommentIcon />
                <span className="comment-label">Comment</span>
                <UserTaggableInput
                  onChange={(value, taggedUsers) => onAddComment(question.id, value, taggedUsers)}
                  value={comment || ''}
                  placeholder="(Optional) Add a comment"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
